// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"a2117b5e","787":"51638d34","911":"76862bc3"}[chunkId] + ".chunk.js";
};